How many search bullet points are accepted when posting a job ad.

This is always a positive integer; if bullet points are not supported, the entire object will be `null`.
